import { render, staticRenderFns } from "./resaleStock.vue?vue&type=template&id=b9e508e4&scoped=true"
import script from "./resaleStock.vue?vue&type=script&lang=js"
export * from "./resaleStock.vue?vue&type=script&lang=js"
import style0 from "./resaleStock.vue?vue&type=style&index=0&id=b9e508e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e508e4",
  null
  
)

export default component.exports